var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_77623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9.17383C18.5 14.1444 14.4706 18.1738 9.5 18.1738C6.46609 18.1738 3.78261 16.6725 2.15234 14.3722H2.15199C1.73443 13.7832 1.38945 13.1461 1.12452 12.4745C0.988706 12.1303 0.874485 11.7779 0.782516 11.4195V11.4191C0.598086 10.7013 0.5 9.94892 0.5 9.17383C0.5 4.20326 4.52943 0.173828 9.5 0.173828C12.2837 0.173828 14.7722 1.43748 16.4227 3.42265C17.0189 4.139 17.5056 4.94935 17.8575 5.82804C18.2719 6.86248 18.5 7.9917 18.5 9.17383Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8563 5.82693L17.854 5.84858C17.8044 6.29345 17.6641 6.7721 17.44 7.26875L17.4397 7.26911L13.5649 17.1287L3.18661 14.6947C3.06188 14.6703 2.93813 14.6413 2.8156 14.6076C2.57721 14.543 2.3553 14.464 2.15108 14.3711H2.15073C1.52698 13.4905 1.05712 12.4932 0.78125 11.4183C0.827423 11.2268 0.876037 11.0359 0.927078 10.8456C1.17908 9.90192 1.66873 8.28449 2.25725 7.43406L2.31455 9.40158L6.19226 9.66019L11.4486 7.16114L13.7177 3.82931L12.7126 2.2207C14.3892 2.62736 15.4516 2.9947 16.1205 3.28453C16.2218 3.32806 16.3221 3.37374 16.4214 3.42154C17.0933 3.74589 17.2222 3.94318 17.2222 3.94318C17.4437 4.12979 17.6098 4.34875 17.7108 4.59927C17.8577 4.96293 17.9036 5.37766 17.8563 5.82693Z",
    fill: "#9B0A0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0416 3.11905C12.3899 1.83534 9.51395 1.98656 6.61797 3.45679C3.72199 4.92703 1.90264 7.15953 2.55435 8.44323C3.20606 9.72693 6.08203 9.57572 8.97802 8.10549C11.874 6.63525 13.6933 4.40275 13.0416 3.11905Z",
    fill: "#EF0E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0897 13.1509L13.5674 17.1303L7.04058 14.5685C8.32913 14.3025 9.71274 13.8323 11.0897 13.1509ZM2.25986 7.43555L2.3173 9.4031L0.929688 10.847C1.18186 9.90345 1.67131 8.28601 2.25986 7.43555Z",
    fill: "#F5655E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.31455 9.40238L1.12325 12.4741C0.987441 12.1299 0.873219 11.7775 0.78125 11.4191V11.4188C0.827555 11.2274 0.876168 11.0366 0.927078 10.8465L2.31455 9.40238ZM13.7179 3.83008L17.8541 5.84935C17.8044 6.29429 17.6643 6.77283 17.4399 7.26973L17.4397 7.27001C17.2719 7.64228 17.0568 8.02489 16.7977 8.4109L13.7179 3.83008Z",
    fill: "#950C10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4373 7.26758L13.5625 17.1271L14.5549 10.8738C15.4838 10.079 16.2407 9.23566 16.7953 8.40843C17.0544 8.02238 17.2695 7.63978 17.4373 7.26758Z",
    fill: "#EF0E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7223 3.83008L16.802 8.4109L11.4531 7.16205L13.7223 3.83008Z",
    fill: "#EF0E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.119 3.2846L13.7163 3.82949L12.7109 2.2207C14.3875 2.62771 15.45 2.99481 16.119 3.2846Z",
    fill: "#F5655E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4476 7.16211L14.556 10.8764C13.6211 11.6766 12.5121 12.4277 11.2588 13.064C11.2011 13.0933 11.1437 13.122 11.0859 13.1504L11.4476 7.16211Z",
    fill: "#950C10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4517 7.16211L11.0901 13.1503L6.19531 9.66102L11.4517 7.16211Z",
    fill: "#EF0E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19531 9.6582L11.09 13.1475C9.71305 13.8289 8.32944 14.299 7.04089 14.5651L6.19531 9.6582Z",
    fill: "#950C10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19016 9.65889L2.81344 14.6065L2.3125 9.40039L6.19016 9.65889Z",
    fill: "#F5655E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_77623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.173828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuby);
export default __webpack_public_path__ + "static/media/ruby.7fe84f04e30372ba1173a3bca02b034b.svg";
export { ForwardRef as ReactComponent };